module.exports = __webpack_public_path__ + "media/reskin-images/icon--locked-3abfaa2f.svg";